import builder from '../builder';
import CreditCard from '../../streamline-icons/light/credit-card-1.svg';

export default builder('IconCreditCardLight', CreditCard);
